<template>
  <div class="bot-selector">
    <a-modal
      title="预绑定机器人"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :closable="false"
      :centered="true"
      :destroyOnClose="true"
      cancelText="取消"
      okText="确定"
      width="400px"
      style="height: 100px"
    >
      将把：
      <a-input v-model="phone" placeholder="输入客户手机号" style="margin: 10px 0 10px 0"></a-input>
      绑定到：
      <!-- 机器人 -->
      <div class="avatar-36-con" style="margin: 10px 0 10px 0">
        <img class="avatar" :src="data != null ? data.base_info.avatar_url : 'defaut'"/>
        <div class="nickname">{{data != null ? data.base_info.nickname + '（' + data.base_info.username + '）' : 'default'}}</div>
      </div>
      <div style="margin: 10px 0 10px 0">
        <label class="info" style="width: 30%">APP</label>
        <a-select v-model="app" style="width: 70%">
          <a-select-option value="zidou"> 紫豆助手 </a-select-option>
          <a-select-option value="yaca"> 友问币答 </a-select-option>
          <a-select-option value="test"> 测试环境 </a-select-option>
        </a-select>
      </div>
      <div style="margin: 10px 0 10px 0">
        <label class="info" style="width: 30%">VIP </label>
        <a-select v-model="vip" style="width: 70%">
          <a-select-option value="0"> 普通用户 </a-select-option>
          <a-select-option value="2"> 企业用户 </a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
import ASelect from 'ant-design-vue/es/select/index'
import AInput from 'ant-design-vue/es/input/Input'
export default {
  name: 'BindClientModal',
  components: {AInput, ASelect},
  props: ['visible', 'confirmLoading', 'data'],
  data () {
    // console.log(this.data)
    return {
      phone: '',
      app: '',
      vip: ''
    }
  },
  methods: {
    handleOk () {
      // console.log('handleOk')
      this.onFinish()
    },
    handleCancel () {
      // console.log('handleCancel')
      this.onCancel()
    },
    onFinish () {
      // console.log('onFinish', this.selectedBotList)
      this.$emit('on-finish', this.data.username, this.phone, this.app, this.vip)
      // console.log('$emit', this.selectedBotList)
      this.phone = ''
      this.vip = ''
      this.app = ''
    },
    onCancel () {
      // console.log('onCancel', this.selectedBotList)
      this.$emit('on-cancel')
    }
  }
}
</script>

<style scoped>

</style>
